import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // console.log('request.url', request.url);
    if (
      request.url == 'http://api.ipify.org/?format=json' ||
      request.url ==
        'https://mxsupport.mobilisepro.com/Webservices/create_ticket_crm.php'
    ) {
      const headers = new HttpHeaders({
        Accept: 'application/json',
      });
      const modifiedReq = request.clone({ headers });
      return next.handle(modifiedReq);
    }
    if (
      localStorage.getItem('token') !== null &&
      localStorage.getItem('token') !== '' &&
      localStorage.getItem('token') !== undefined
    ) {
      const userToken = localStorage.getItem('token');
      const headers = new HttpHeaders({
        Authorization: `Bearer ${userToken}`,
        Accept: 'application/json',
      });
      const modifiedReq = request.clone({ headers });
      return next.handle(modifiedReq).pipe(
        tap(
          () => {},
          (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status !== 401) {
                return;
              }
              const popUp = localStorage.getItem('popUp');
              const date = localStorage.getItem('date');
              const usrId = localStorage.getItem('usrId');
              const ballon = localStorage.getItem('showBallon');
              const evntDate = localStorage.getItem('eventDate');

              localStorage.clear();
              localStorage.setItem('popUp', popUp);
              localStorage.setItem('date', date);
              localStorage.setItem('usrId', usrId);
              localStorage.setItem('showBallon', ballon);
              localStorage.setItem('eventDate', evntDate);

              this.router.navigate(['/auth']);
            }
          }
        )
      );
    } else {
      if (
        localStorage.getItem('authtoken') !== null &&
        localStorage.getItem('authtoken') !== '' &&
        localStorage.getItem('authtoken') !== undefined
      ) {
        const userToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({
          Authorization: `Bearer ${userToken}`,
          Accept: 'application/json',
        });
        const modifiedReq = request.clone({ headers });
        return next.handle(modifiedReq).pipe(
          tap(
            () => {},
            (err: any) => {
              if (err instanceof HttpErrorResponse) {
                if (err.status !== 401) {
                  return;
                }
                const popUp = localStorage.getItem('popUp');
                const date = localStorage.getItem('date');
                const usrId = localStorage.getItem('usrId');
                const ballon = localStorage.getItem('showBallon');
                const evntDate = localStorage.getItem('eventDate');

                localStorage.clear();
                localStorage.setItem('popUp', popUp);
                localStorage.setItem('date', date);
                localStorage.setItem('usrId', usrId);
                localStorage.setItem('showBallon', ballon);
                localStorage.setItem('eventDate', evntDate);

                this.router.navigate(['/auth']);
              }
            }
          )
        );
      } else {
        const headers = new HttpHeaders({
          Accept: 'application/json',
        });
        const modifiedReq = request.clone({ headers });
        return next.handle(modifiedReq);
      }
    }
  }
}
